<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading text="Share Results" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/results-sharing"
        >
          <i class="fal fa-list" />
        </b-button>

        <b-button
          variant="info"
          class="ml-1"
          :to="`/results-sharing/${result_sharing_id}`"
        >
          <i class="fal fa-eye" />
        </b-button>
      </template>
    </default-heading>

    <div class="mb-3">
      <b-alert variant="info" show>
        <i class="fa fa-info-circle" />
        Shared results are made available to other customers. Results can be shared for entire sample types, date ranges, crop types, etc. 
        To share results you will need to obtain the other user's 'DTE Customer Number'. To do so you will need to contact either DTE
        or the user you are trying to share data with.
      </b-alert>
      <ResultSharingForm :result_sharing="result_sharing" :submittingForm="submittingForm" :error="error" @submit="submit" />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import ResultSharingForm from '@/components/results/resultsharing/ResultSharingForm'
import ResultSharingModel from '@/models/result/ResultSharingModel'
import LoadingOverlay from '@/components/shared/LoadingOverlay'

export default {
  name: 'ResultSharingAdd',
  components: {
    DefaultHeading,
    ResultSharingForm,
    LoadingOverlay
  },
  data () {
    return {
      error: null,
      submittingForm: false,
      loading: true,
      result_sharing_id: this.$route.params.id,
      result_sharing: null,
    }
  },
  mounted () {
    this.fetchResultSharing()
  },
  methods: {
    fetchResultSharing () {
      const model = new ResultSharingModel({ id: this.result_sharing_id })
      model.fetch().then(() => {
        this.result_sharing = model
        this.loading = false
      })
    },

    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        this.result_sharing.set('starts_at', form_data.starts_at)
        this.result_sharing.set('ends_at', form_data.ends_at)

        await this.result_sharing.save()
        
        this.$bvToast.toast('Shared Results Updated', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/results-sharing/' + this.result_sharing_id)
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please contact an administrator'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
